<template>
  <div class="foot">
    <div class="main">
      <div class="about">
        <div class="left">
          <p class="tit">联系我们</p>
          <div class="text">
            <p>技术合作：service@hwelltech.com</p>
            <p>商务洽谈：marketing@hwelltech.com</p>
            <p>战略部署：blockchain@hwelltech.com</p>
            <p>人才招聘：0510-85386599</p>
            <p>公司地址：无锡市新吴区菱湖大道111号天鹅座D栋19层</p>

          </div>
        </div>
        <div class="right">
          <div class="img">
            <img
              src="../../assets/images/pc/foot-wx.png"
              alt=""
            >
          </div>
          <div class="txt">
            <p>扫码关注“恒为信息科技”</p>
            <p>官方微信公众号了解更多资讯</p>
          </div>
        </div>
      </div>
      <div class="zf">

        <span>CopyRight&nbsp; ©&nbsp; 2015~{{currentYear}}&nbsp; {{$t('common.footer1')}}</span>
        <a
          href="http://beian.miit.gov.cn"
          target="_blank"
        >{{$t('common.footer2')}}</a>

        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32021402001207"
        >
          <!-- <img src="../../assets/images/pc/footimg.png" style="float:left;" /> -->
          <!-- <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">苏公网安备 32021402001207号</p> -->
          苏公网安备 32021402001207号
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs"
export default {
  name: "Foot",
  data() {
    return {
      currentYear: dayjs(new Date()).format("YYYY")
    };
  },
};
</script>

<style scoped lang="less">
@import url("../../assets/css/var.less");

.foot {
  background: #0f0f13;
  min-width: @min-width;
  height: 371px;
  .main {
    .about {
      display: flex;
      justify-content: space-between;
      padding: 60px 0 30px;
      border-bottom: 1px solid #424348;
      .left {
        width: 345px;
        .tit {
          color: #aeaeae;
          font-size: 16px;
          margin-bottom: 25px;
        }
        .text {
          p {
            color: #aeaeae;
            font-size: 14px;
            height: 28px;
            line-height: 28px;
          }
        }
      }
      .right {
        display: flex;
        .img {
          margin-top: 49px;
          width: 130px;
          height: 130px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .txt {
          margin: 85px 0 0 25px;
          width: 190px;
          p {
            color: #aeaeae;
            font-size: 14px;
            height: 30px;
            line-height: 30px;
          }
        }
      }
    }
    .zf {
      height: 94px;

      span {
        display: inline-block;
        height: 94px;
        font-size: 14px;
        color: #aeaeae;
        line-height: 94px;
        margin-right: 20px;
      }
      a {
        display: inline-block;
        height: 94px ;
        line-height: 94px ;
        color: #aeaeae;
        text-decoration:none;
        margin: 0  20px;
      }
    }
  }
}
</style>
